export default {
  scroll: 'SCROLL',
  detail: 'DETAIL'
};
